/**
 * Mixin for handle resources action buttons (Cancel/Save) in Create and Edit pages also exit modal handling
 */
export default {
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    isDirtyForm(val) {
      this.showModal = val;
    },
  },
};
